import { createCallable } from "./_sdk/client";

//////// AI ////////
import type { handlers as aiHandlers } from "./ai/handlers";
const ai = createCallable<typeof aiHandlers>("ai");
////////////////////

//////// REFINER SIGNATURE ////////
import type { handlers as refinerSignatureHandlers } from "./refiner/handlers";
const refiner = createCallable<typeof refinerSignatureHandlers>("refiner");
////////////////////

//////// SEARCH ////////
import type { handlers as searchHandlers } from "./search/handlers";
const search = createCallable<typeof searchHandlers>("search");
////////////////////

//////// ZENDESK ////////
import type { handlers as zendeskHandlers } from "./zendesk/handlers";
const zendesk = createCallable<typeof zendeskHandlers>("zendesk");
////////////////////

export {
    ai,
    refiner,
    search,
    zendesk
};
